import { getConfig } from '@superbet-group/web.lib.config';
import { Locale } from '@superbet-group/web.types';
import {
    createCTRestClient,
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';
import { getClientSourceParam } from '@superbet-group/web.lib.vue-utilities';

import { defaultHttpTimeoutMs } from '@core/constants';

export default class RestService {
    private readonly restClient: RestClient = createCTRestClient(
        getConfig().auth.host,
        defaultHttpTimeoutMs,
        getClientSourceParam(),
        true,
    );

    private readonly ftpRestClient: RestClient = createRestClient(
        `${getConfig().ftpIntegrationLayer?.baseUrl}/${getConfig().countrySpecific.country}`,
        defaultHttpTimeoutMs,
    );

    public getAccessToken(): Promise<{ jwt: string }> {
        return this.restClient.post('/integrations/getAccessToken');
    }

    public launchGame(sessionId: string, gameId: string, locale: Locale): Promise<LaunchGameResponse> {
        return this.ftpRestClient.post<LaunchGameRequest, LaunchGameResponse>(`/${gameId}/game`, {
            locale,
            session_id: sessionId,
        });
    }
}

/* eslint-disable camelcase */
type LaunchGameRequest = {
    session_id: string;
    locale: string;
};

type LaunchGameResponse = {
    provider_url: string;
};
/* eslint-enable camelcase */
